var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('v-container',[(!_vm.$store.getters.pagesFormStatus && !_vm.$store.getters.pagePublishRequest)?_c('v-card',[_c('v-card-title',[_c('div',{staticClass:"w-100 d-flex flex-row justify-content-between"},[_c('div',[_vm._v(" مدیریت فعالیت های کسب و کار ")])])]),_c('v-divider'),_c('v-card-text',[_c('my-activity-list')],1)],1):_vm._e()],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }